import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

import Arranger from '~c/components/base/arranger';
import { Radio } from '~c/components/base/radio';
import { spc } from '~c/components/base/spacer';
import Text from '~c/components/base/text';

interface Props {
  className?: string;
}

const RadioNoGroupDemo: React.FC<Props> = ({ className }) => {
  const [selectedValue, setSelectedValue] = React.useState('a');

  return (
    <Arranger
      className={className}
      direction="column"
      sx={{ pl: spc.between_horizontal_s }}
    >
      <Text>Without RadioGroup</Text>
      <Radio
        label="Check 1"
        checked={selectedValue === 'a'}
        onChange={() => setSelectedValue('a')}
        value="a"
      />
      <Radio
        label="Check 2"
        checked={selectedValue === 'b'}
        onChange={() => setSelectedValue('b')}
        value="b"
      />
    </Arranger>
  );
};

export default muiStyled(RadioNoGroupDemo)(({ theme }) => css``);
